<div class="onboarding-track-page" *ngIf="!carregando && (aguardandoProposta || concluido)">
  <section class="onboarding-track-panel">
    <header class="track-header">
      <div>
        <span class="panel-eyebrow">Acompanhamento Ativaçao MeucardapioPay</span>
        <h1>{{tituloAcompanhamento()}}</h1>
        <p>{{proximoPassoAcompanhamento()}}</p>
      </div>
      <button type="button" class="btn btn-outline-secondary" (click)="voltarFormasPagamento()">Formas de pagamento</button>
    </header>

    <div class="track-meta" *ngIf="propostaAcompanhamento()">
      <span><strong>Status:</strong> {{statusPropostaAtual()}}</span>
      <span *ngIf="propostaAcompanhamento()?.clientCode"><strong>Proposta:</strong> {{propostaAcompanhamento()?.clientCode}}</span>
      <span *ngIf="dataPropostaAtual()"><strong>Atualizado:</strong> {{dataPropostaAtual() | date:'dd/MM/yyyy HH:mm'}}</span>
      <span *ngIf="deveExibirPollingStatusProposta()"><strong>Automático:</strong> consulta a cada 30 segundos</span>
    </div>

    <div class="track-steps">
      <article class="track-step"
               *ngFor="let passo of passosAcompanhamento"
               [ngClass]="classePassoAcompanhamento(passo)">
        <span class="track-step-number">{{passo.numero}}</span>
        <div>
          <strong>{{passo.titulo}}</strong>
          <small>{{passo.descricao}}</small>
          <button type="button"
                  class="btn btn-outline-primary btn-sm track-kyc-files-action"
                  *ngIf="passo.id === 'documentos' && podeVerArquivosKyc()"
                  (click)="abrirArquivosKyc()">
            <i class="far fa-file-alt"></i>
            Ver documentos
          </button>
        </div>
      </article>
    </div>

    <article class="track-validation-callout" *ngIf="documentoscopiaPendente() && !contaCellcoinCriada() && !propostaReprovada()">
      <div class="validation-icon">3</div>
      <div class="validation-copy">
        <span>Validação facial e documentos disponível</span>
        <strong>O responsável já pode abrir o link para tirar foto e enviar os documentos.</strong>
        <small>Depois da conclusão, a análise continua até a criação da conta.</small>
      </div>
      <button type="button" class="btn btn-primary" (click)="abraValidacaoDocumentos()">
        Abrir link de validação
      </button>
    </article>

    <div class="track-summary-grid">
      <article class="track-summary-card">
        <span>Onde estamos</span>
        <strong>{{ondeEstamosAcompanhamento()}}</strong>
      </article>
      <article class="track-summary-card">
        <span>O que estamos aguardando</span>
        <strong>{{aguardandoAcompanhamento()}}</strong>
      </article>
      <article class="track-summary-card">
        <span>Próximo passo</span>
        <strong>{{proximoPassoAcompanhamento()}}</strong>
      </article>
    </div>

    <div class="track-actions">
      <button type="button"
              class="btn track-primary-action"
              *ngIf="podeComecarUsarCellcoin()"
              (click)="comecarUsarCellcoin()"
              [disabled]="migrando">
        <span class="spinner-border spinner-border-sm mr-1" *ngIf="migrando"></span>
        Começar a usar Meu Cardápio Pay 2.0
      </button>
      <button type="button"
              class="btn btn-primary"
              *ngIf="podeIrParaFormasPagamento()"
              (click)="voltarFormasPagamento()">
        Ir para liberar Pix e Cartão
      </button>
      <button type="button"
              class="btn btn-outline-primary"
              *ngIf="podeAtualizarAcompanhamento()"
              (click)="sincronizarPropostaAtual()"
              [disabled]="enviando">
        <span class="spinner-border spinner-border-sm mr-1" *ngIf="enviando"></span>
        Atualizar status
      </button>
      <button type="button"
              class="btn btn-outline-secondary"
              *ngIf="propostaAcompanhamento()"
              (click)="abrirWebhooksOnboarding()"
              [disabled]="carregandoWebhooks">
        <span class="spinner-border spinner-border-sm mr-1" *ngIf="carregandoWebhooks"></span>
        Ver webhooks
      </button>
      <button type="button"
              class="btn btn-outline-secondary"
              *ngIf="usuarioAdmin && propostaAcompanhamento()"
              (click)="abrirDadosTermoAceite()">
        Ver dados do aceite
      </button>
      <button type="button"
              class="btn track-primary-action"
              *ngIf="propostaReprovada()"
              (click)="fazerNovaProposta()"
              [disabled]="enviando">
        <span class="spinner-border spinner-border-sm mr-1" *ngIf="enviando"></span>
        Fazer nova proposta
      </button>
    </div>

    <div class="alert alert-danger mt-3" *ngIf="mensagemErro">{{mensagemErro}}</div>
    <div class="alert alert-success mt-3" *ngIf="mensagemSucesso">{{mensagemSucesso}}</div>
  </section>
</div>

<div class="webhook-modal-backdrop" *ngIf="modalArquivosKycAberto">
  <section class="webhook-modal kyc-files-modal">
    <header class="webhook-modal-header">
      <div>
        <span class="panel-eyebrow">Documentos KYC</span>
        <h2>Arquivos enviados na validação</h2>
        <p>Proposta {{propostaAcompanhamento()?.clientCode || propostaAcompanhamento()?.proposalId || '-'}}</p>
      </div>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="fecharArquivosKyc()">Fechar</button>
    </header>

    <div class="webhook-modal-body">
      <div class="webhook-loading" *ngIf="carregandoArquivosKyc">
        <span class="spinner-border spinner-border-sm mr-2"></span>
        Consultando documentos...
      </div>

      <div class="alert alert-danger kyc-files-alert" *ngIf="erroArquivosKyc">{{erroArquivosKyc}}</div>

      <div class="webhook-empty" *ngIf="!carregandoArquivosKyc && !erroArquivosKyc && !arquivosKyc.length">
        Nenhum documento foi retornado para esta proposta.
      </div>

      <div class="kyc-files-grid" *ngIf="!carregandoArquivosKyc && arquivosKyc.length">
        <article class="kyc-file-card" *ngFor="let arquivo of arquivosKyc">
          <div class="kyc-file-preview">
            <img *ngIf="arquivoKycEhImagem(arquivo)"
                 [src]="arquivo.url"
                 [alt]="rotuloTipoArquivoKyc(arquivo.type)"
                 loading="lazy">
            <i class="far fa-file-pdf" *ngIf="!arquivoKycEhImagem(arquivo)"></i>
          </div>
          <div class="kyc-file-info">
            <strong>{{rotuloTipoArquivoKyc(arquivo.type)}}</strong>
            <span>{{arquivo.type || 'DOCUMENTO'}}</span>
            <small *ngIf="arquivo.expirationTime">Link válido até {{arquivo.expirationTime | date:'dd/MM/yyyy HH:mm:ss'}}</small>
          </div>
          <a class="btn btn-outline-primary btn-sm"
             [href]="arquivo.url"
             target="_blank"
             rel="noopener noreferrer">
            Abrir documento
          </a>
        </article>
      </div>
    </div>
  </section>
</div>

<div class="webhook-modal-backdrop" *ngIf="modalTermoAceiteAberto">
  <section class="webhook-modal term-acceptance-modal">
    <header class="webhook-modal-header">
      <div>
        <span class="panel-eyebrow">Evidência do aceite</span>
        <h2>Termo de uso da conta Cellcoin</h2>
        <p>Dados coletados no envio da proposta {{dadosTermoAceite().clientCode || '-'}}</p>
      </div>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="fecharDadosTermoAceite()">Fechar</button>
    </header>

    <div class="webhook-modal-body">
      <div class="alert alert-warning term-acceptance-alert" *ngIf="!dadosTermoAceite().termoAceito">
        Esta proposta não possui evidência de aceite do termo registrada.
      </div>

      <div class="term-acceptance-status" *ngIf="dadosTermoAceite().termoAceito">
        <i class="fas fa-check-circle"></i>
        <div>
          <strong>Termo aceito</strong>
          <span>{{dadosTermoAceite().termoAceitoEm | date:'dd/MM/yyyy HH:mm:ss'}}</span>
        </div>
      </div>

      <dl class="term-acceptance-grid">
        <div>
          <dt>Versão do termo</dt>
          <dd>{{dadosTermoAceite().termoVersao || 'Não informada'}}</dd>
        </div>
        <div>
          <dt>Usuário responsável</dt>
          <dd>
            <strong>{{dadosTermoAceite().termoUsuario?.nome || 'Não informado'}}</strong>
            <span class="term-user-phone" *ngIf="dadosTermoAceite().termoUsuario?.telefone">
              {{dadosTermoAceite().termoUsuario.telefone}}
            </span>
          </dd>
        </div>
        <div>
          <dt>Endereço IP</dt>
          <dd>{{dadosTermoAceite().termoIp || 'Não informado'}}</dd>
        </div>
        <div>
          <dt>Proposta</dt>
          <dd>{{dadosTermoAceite().clientCode || dadosTermoAceite().proposalId || 'Não informada'}}</dd>
        </div>
        <div class="term-acceptance-wide">
          <dt>Termo apresentado</dt>
          <dd>
            <a *ngIf="dadosTermoAceite().termoUrl" [href]="dadosTermoAceite().termoUrl" target="_blank" rel="noopener noreferrer">
              {{dadosTermoAceite().termoUrl}}
            </a>
            <span *ngIf="!dadosTermoAceite().termoUrl">Não informado</span>
          </dd>
        </div>
        <div class="term-acceptance-wide">
          <dt>Navegador e dispositivo</dt>
          <dd class="term-user-agent">{{dadosTermoAceite().termoUserAgent || 'Não informado'}}</dd>
        </div>
      </dl>
    </div>
  </section>
</div>

<div class="webhook-modal-backdrop" *ngIf="modalWebhooksAberto">
  <section class="webhook-modal">
    <header class="webhook-modal-header">
      <div>
        <span class="panel-eyebrow">Webhooks de ativação</span>
        <h2>Onboarding enviados</h2>
        <p *ngIf="webhooksOnboarding">
          Proposta {{webhooksOnboarding.clientCode || '-'}} · {{webhooksOnboarding.dateFrom | date:'dd/MM/yyyy HH:mm'}} até {{webhooksOnboarding.dateTo | date:'dd/MM/yyyy HH:mm'}}
        </p>
      </div>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="fecharWebhooksOnboarding()">Fechar</button>
    </header>

    <div class="webhook-modal-body">
      <div class="webhook-loading" *ngIf="carregandoWebhooks">
        <span class="spinner-border spinner-border-sm mr-2"></span>
        Consultando webhooks enviados...
      </div>

      <div class="alert alert-danger" *ngIf="erroWebhooks">{{erroWebhooks}}</div>

      <div class="alert alert-warning" *ngIf="!carregandoWebhooks && !erroWebhooks && webhooksOnboarding && quantidadeWebhooksOnboarding() === 0">
        Nenhum webhook de onboarding encontrado para esta proposta no período consultado.
      </div>

      <div class="alert alert-warning" *ngIf="!carregandoWebhooks && !erroWebhooks && semWebhookCreateDaPropostaAtual()">
        Não encontramos webhook de criação da conta para esta proposta no período consultado.
      </div>

      <article class="webhook-entity" *ngFor="let consulta of consultasWebhooksOnboarding()">
        <div class="webhook-entity-header">
          <div>
            <strong>{{consulta.label}}</strong>
            <span>{{consulta.entity}}</span>
          </div>
          <span class="webhook-count">{{(consulta.webhooks || []).length}}</span>
        </div>

        <div class="alert alert-danger" *ngIf="consulta.erro">{{consulta.erro}}</div>
        <div class="webhook-empty" *ngIf="!consulta.erro && !(consulta.webhooks || []).length">
          Nenhum envio encontrado para essa entidade.
        </div>

        <div class="webhook-detail"
             *ngFor="let detalhe of consulta.webhooks"
             [ngClass]="classeWebhookDetalhe(detalhe)">
          <div class="webhook-detail-summary">
            <div>
              <strong>{{statusWebhookDetalhe(detalhe)}}</strong>
              <span *ngIf="detalhe.webhookId">{{detalhe.webhookId}}</span>
            </div>
            <div class="webhook-detail-meta">
              <span *ngIf="detalhe.matchProposal" class="match-tag">proposta atual</span>
              <span *ngIf="detalhe.httpStatusCode">HTTP {{detalhe.httpStatusCode}}</span>
              <span *ngIf="detalhe.createDate">{{detalhe.createDate | date:'dd/MM/yyyy HH:mm:ss'}}</span>
            </div>
          </div>

          <div class="webhook-url" *ngIf="detalhe.webhookUrl">{{detalhe.webhookUrl}}</div>

          <details class="webhook-payload">
            <summary>Request</summary>
            <pre>{{formateJsonWebhook(detalhe.request)}}</pre>
          </details>

          <details class="webhook-payload">
            <summary>Response</summary>
            <pre>{{formateJsonWebhook(detalhe.response)}}</pre>
          </details>
        </div>
      </article>
    </div>
  </section>
</div>

<div class="pay-activation" *ngIf="!concluido && !aguardandoProposta">
  <aside class="pay-sidebar">
    <div class="sidebar-brand">
      <div class="brand-mark">MP</div>
      <div class="sidebar-title">
        <span>Meu Cardápio Pay</span>
        <strong>Ativação</strong>
      </div>
    </div>

    <div class="progress-box">
      <div class="progress-meta">
        <span>Etapa {{indiceEtapa + 1}} de {{etapas().length}}</span>
        <strong>{{progresso() | number:'1.0-0'}}%</strong>
      </div>
      <div class="progress-track">
        <span [style.width.%]="progresso()"></span>
      </div>
    </div>

    <div class="step-list">
      <button type="button"
              *ngFor="let etapa of etapas(); let i = index"
              class="step-item"
              [class.is-active]="i === indiceEtapa"
              [class.is-done]="etapaConcluida(etapa)"
              (click)="selecioneEtapa(i)">
        <span class="step-index">{{etapaConcluida(etapa) ? 'OK' : i + 1}}</span>
        <span class="step-copy">
          <strong>{{etapa.label}}</strong>
          <small>{{etapa.titulo}}</small>
        </span>
      </button>
    </div>

    <div class="sidebar-footer">
      <strong>Cadastro seguro</strong>
      <span>Dados enviados somente para validação da conta Celcoin.</span>
    </div>
  </aside>

  <section class="pay-panel">
    <header class="panel-header">
      <div>
        <span class="panel-eyebrow">Cadastro obrigatório</span>
        <h1>{{etapaAtual()?.titulo}}</h1>
        <p>{{etapaAtual()?.subtitulo}}</p>
      </div>
      <button type="button" class="btn btn-outline-secondary" (click)="voltarFormasPagamento()">Sair</button>
    </header>

    <div class="alert alert-danger" *ngIf="mensagemErro">{{mensagemErro}}</div>
    <div class="alert alert-success" *ngIf="mensagemSucesso">{{mensagemSucesso}}</div>

    <main class="panel-body" *ngIf="!carregando">
      <section *ngIf="etapaAtual()?.id === 'empresa'" class="step-screen">
        <article class="activation-card">
          <div class="activation-card-header">
            <div class="card-title-wrap">
              <div class="card-icon">ID</div>
              <div>
                <h2>Documento da conta</h2>
                <p>Informe CPF ou CNPJ para iniciar o cadastro Celcoin.</p>
              </div>
            </div>
            <span class="required-tag">Obrigatório</span>
          </div>

          <div class="activation-card-body">
            <div class="document-row">
              <div class="field">
                <label>{{documentoLabel()}}</label>
                <div class="document-control has-action" [class.is-invalid]="documentoContaInvalido()">
                  <input class="form-control" name="documentNumber"
                         [(ngModel)]="proposta.documentNumber"
                         (ngModelChange)="mudouDocumento()"
                         [mask]="mascaraDocumentoConta()"
                         placeholder="CPF ou CNPJ">
                  <button type="button" class="btn btn-outline-primary document-action" *ngIf="ehPessoaJuridica()" (click)="buscarCnpj()" [disabled]="buscandoCnpj">
                    <span class="spinner-border spinner-border-sm mr-1" *ngIf="buscandoCnpj"></span>
                    Buscar dados
                  </button>
                  <button type="button" class="btn btn-outline-secondary document-action document-toggle" (click)="alternarDocumentoConta()">
                    {{labelAlternarDocumentoConta()}}
                  </button>
                </div>
                <div class="helper-line" [class.is-success]="documentoContaCompleto()">
                  <span class="helper-dot"></span>
                  <span>{{textoAjudaDocumentoConta()}}</span>
                </div>
              </div>
            </div>
          </div>
        </article>

        <article class="activation-card" *ngIf="ehPessoaJuridica()">
          <div class="activation-card-header">
            <div class="card-title-wrap">
              <div class="card-icon">PJ</div>
              <div>
                <h2>Dados cadastrais</h2>
                <p>Confira as informações da empresa antes de avançar.</p>
              </div>
            </div>
          </div>

          <div class="activation-card-body">
            <div class="form-grid">
              <div class="field">
                <label>Razão social</label>
                <input class="form-control" name="businessName" [(ngModel)]="proposta.businessName" maxlength="350" [class.is-invalid]="nomeEmpresaInvalido(proposta.businessName, 350)">
              </div>
              <div class="field">
                <label>Nome fantasia</label>
                <input class="form-control" name="tradingName" [(ngModel)]="proposta.tradingName" maxlength="120" [class.is-invalid]="nomeEmpresaInvalido(proposta.tradingName, 120)">
              </div>
              <div class="field md">
                <label>Tipo da empresa</label>
                <select class="form-control" name="companyType" [(ngModel)]="proposta.companyType" (ngModelChange)="mudouCompanyType()" [class.is-invalid]="campoObrigatorioInvalido('empresa', proposta.companyType)">
                  <option *ngFor="let tipo of companyTypes" [ngValue]="tipo.id">{{tipo.nome}}</option>
                </select>
              </div>
              <div class="field">
                <label>Telefone da empresa</label>
                <div class="phone-control" [class.is-invalid]="telefoneInvalido('empresa', proposta.contactNumber, codigoPaisEmpresa)">
                  <app-seletor-codigo-pais-server
                    [selectedCountryCode]="codigoPaisEmpresa"
                    (selectedCountryCodeChange)="atualizeCodigoPaisEmpresa($event)">
                  </app-seletor-codigo-pais-server>
                  <input class="form-control" name="contactNumber"
                         [ngModel]="telefoneNacional(proposta.contactNumber, codigoPaisEmpresa)"
                         (ngModelChange)="atualizeTelefoneEmpresa($event)"
                         mask="(00) 00000-0000"
                         placeholder="(00) 00000-0000">
                </div>
              </div>
              <div class="field">
                <label>E-mail da empresa</label>
                <input class="form-control" name="businessEmail" [(ngModel)]="proposta.businessEmail" type="email" [class.is-invalid]="emailInvalido('empresa', proposta.businessEmail)">
              </div>
            </div>
          </div>
        </article>
      </section>

      <section *ngIf="etapaAtual()?.id === 'responsavel'" class="step-screen activation-card">
        <div class="activation-card-header">
          <div class="card-title-wrap">
            <div class="card-icon">PF</div>
            <div>
              <h2>Dados do responsável</h2>
              <p>Complete os dados do representante da conta.</p>
            </div>
          </div>
        </div>

        <div class="activation-card-body">
        <div class="info-strip">
          Esses dados são usados na análise cadastral e na validação da conta de pagamento.
        </div>

        <div class="form-grid">
          <div class="field md" *ngIf="!ehPessoaFisica()">
            <label>Tipo</label>
            <select class="form-control" name="ownerType0" [(ngModel)]="ownerPrincipal().ownerType" [disabled]="proposta.companyType === 'MEI'">
              <option [ngValue]="'SOCIO'">Sócio responsável</option>
              <option [ngValue]="'REPRESENTANTE'" *ngIf="proposta.companyType !== 'MEI'">Representante legal</option>
            </select>
          </div>
          <div class="field md">
            <label>CPF</label>
            <input class="form-control" name="ownerDocument0" [(ngModel)]="ownerPrincipal().documentNumber" mask="000.000.000-00" placeholder="000.000.000-00" [disabled]="ehPessoaFisica()" [class.is-invalid]="cpfOwnerInvalido(ownerPrincipal(), 'responsavel')">
          </div>
          <div class="field lg">
            <label>Nome completo</label>
            <input class="form-control" name="ownerName0" [(ngModel)]="ownerPrincipal().fullName" [class.is-invalid]="nomeCompletoInvalido('responsavel', ownerPrincipal().fullName)">
          </div>
          <div class="field md">
            <label>Nascimento</label>
            <kendo-datepicker
              class="form-control"
              [class.is-invalid]="campoObrigatorioInvalido('responsavel', ownerPrincipal().birthDate)"
              name="ownerBirth0"
              [(ngModel)]="ownerPrincipal().birthDate"
              format="dd/MM/yyyy"
              activeView="decade">
              <kendo-datepicker-messages
                today="Hoje"
                toggle="Trocar calendário">
              </kendo-datepicker-messages>
            </kendo-datepicker>
          </div>
          <div class="field lg">
            <label>Nome da mãe</label>
            <input class="form-control" name="ownerMother0" [(ngModel)]="ownerPrincipal().motherName" [class.is-invalid]="nomeCompletoInvalido('responsavel', ownerPrincipal().motherName)">
          </div>
          <div class="field md">
            <label>Pessoa politicamente exposta?</label>
            <select class="form-control" name="ownerPep0" [(ngModel)]="ownerPrincipal().isPoliticallyExposedPerson">
              <option *ngFor="let item of respostasPep" [ngValue]="item.valor">{{item.nome}}</option>
            </select>
          </div>
        </div>

        <div class="choice-grid" *ngIf="!ehPessoaFisica()">
          <label class="check-card">
            <input type="checkbox" [(ngModel)]="responsavelUsaTelefoneEmpresa" name="responsavelUsaTelefoneEmpresa">
            <span><strong>Usar telefone da empresa</strong><small>{{proposta.contactNumber || 'Telefone não informado'}}</small></span>
          </label>
          <label class="check-card">
            <input type="checkbox" [(ngModel)]="responsavelUsaEmailEmpresa" name="responsavelUsaEmailEmpresa">
            <span><strong>Usar e-mail da empresa</strong><small>{{proposta.businessEmail || 'E-mail não informado'}}</small></span>
          </label>
          <label class="check-card">
            <input type="checkbox" [(ngModel)]="responsavelUsaEnderecoEmpresa" name="responsavelUsaEnderecoEmpresa">
            <span><strong>Usar endereço comercial</strong><small>{{resumoEndereco(proposta.businessAddress)}}</small></span>
          </label>
        </div>

        <div class="form-grid mt-3" *ngIf="ehPessoaFisica() || !responsavelUsaTelefoneEmpresa || !responsavelUsaEmailEmpresa">
          <div class="field" *ngIf="ehPessoaFisica() || !responsavelUsaTelefoneEmpresa">
            <label>Telefone do responsável</label>
            <div class="phone-control" [class.is-invalid]="telefoneInvalido('responsavel', ownerPrincipal().phoneNumber, ownerPrincipal().phoneCountryCode || '+55')">
              <app-seletor-codigo-pais-server
                [selectedCountryCode]="ownerPrincipal().phoneCountryCode || '+55'"
                (selectedCountryCodeChange)="atualizeCodigoPaisOwner(ownerPrincipal(), $event)">
              </app-seletor-codigo-pais-server>
              <input class="form-control" name="ownerPhone0"
                     [ngModel]="telefoneNacional(ownerPrincipal().phoneNumber, ownerPrincipal().phoneCountryCode || '+55')"
                     (ngModelChange)="atualizeTelefoneOwner(ownerPrincipal(), $event)"
                     mask="(00) 00000-0000"
                     placeholder="(00) 00000-0000">
            </div>
          </div>
          <div class="field" *ngIf="ehPessoaFisica() || !responsavelUsaEmailEmpresa">
            <label>E-mail do responsável</label>
            <input class="form-control" name="ownerEmail0" [(ngModel)]="ownerPrincipal().email" type="email" [class.is-invalid]="emailInvalido('responsavel', ownerPrincipal().email)">
          </div>
        </div>

        <ng-container *ngIf="!responsavelUsaEnderecoEmpresa">
          <ng-container *ngTemplateOutlet="enderecoFields; context: {endereco: ownerPrincipal().address, prefix: 'owner0'}"></ng-container>
        </ng-container>
        </div>
      </section>

      <section *ngIf="etapaAtual()?.id === 'socios'" class="step-screen activation-card">
        <div class="activation-card-body">
        <div class="section-head">
          <div>
            <h2>Sócios adicionais</h2>
            <p>Informe os demais sócios que precisam entrar na análise Celcoin.</p>
          </div>
          <button type="button" class="btn btn-outline-primary" (click)="adicioneSocio()">Adicionar sócio</button>
        </div>

        <div class="empty-state" *ngIf="proposta.owner.length <= 1">

          É importante informar todos os sócios do Quadro Societário da empresa,
          ou pelo menos os que possuem participação societária maior ou igual a 25%.
        </div>

        <article class="owner-card mt-2" *ngFor="let owner of proposta.owner; let i = index" [hidden]="i === 0">
          <div class="owner-card-head">
            <strong>{{ownerLabel(i)}}</strong>
            <button type="button" class="btn btn-link text-danger" (click)="removaSocio(i)">Remover</button>
          </div>

          <div class="form-grid">
            <div class="field md">
              <label>Tipo</label>
              <select class="form-control" name="ownerType{{i}}" [(ngModel)]="owner.ownerType">
                <option *ngFor="let tipo of ownerTypes" [ngValue]="tipo.id">{{tipo.nome}}</option>
              </select>
            </div>
            <div class="field md">
              <label>CPF</label>
              <input class="form-control" name="ownerDocument{{i}}" [(ngModel)]="owner.documentNumber" mask="000.000.000-00" placeholder="000.000.000-00" [class.is-invalid]="cpfOwnerInvalido(owner, 'socios')">
            </div>
            <div class="field lg">
              <label>Nome completo</label>
              <input class="form-control" name="ownerName{{i}}" [(ngModel)]="owner.fullName" [class.is-invalid]="nomeCompletoInvalido('socios', owner.fullName)">
            </div>
            <div class="field">
              <label>Telefone</label>
              <div class="phone-control" [class.is-invalid]="telefoneInvalido('socios', owner.phoneNumber, owner.phoneCountryCode || '+55')">
                <app-seletor-codigo-pais-server
                  [selectedCountryCode]="owner.phoneCountryCode || '+55'"
                  (selectedCountryCodeChange)="atualizeCodigoPaisOwner(owner, $event)">
                </app-seletor-codigo-pais-server>
                <input class="form-control" name="ownerPhone{{i}}"
                       [ngModel]="telefoneNacional(owner.phoneNumber, owner.phoneCountryCode || '+55')"
                       (ngModelChange)="atualizeTelefoneOwner(owner, $event)"
                       mask="(00) 00000-0000"
                       placeholder="(00) 00000-0000">
              </div>
            </div>
            <div class="field">
              <label>E-mail</label>
              <input class="form-control" name="ownerEmail{{i}}" [(ngModel)]="owner.email" type="email" [class.is-invalid]="emailInvalido('socios', owner.email)">
            </div>
            <div class="field md">
              <label>Nascimento</label>
              <kendo-datepicker
                class="form-control"
                [class.is-invalid]="campoObrigatorioInvalido('socios', owner.birthDate)"
                name="ownerBirth{{i}}"
                [(ngModel)]="owner.birthDate"
                format="dd/MM/yyyy"
                activeView="decade">
                <kendo-datepicker-messages
                  today="Hoje"
                  toggle="Trocar calendário">
                </kendo-datepicker-messages>
              </kendo-datepicker>
            </div>
            <div class="field lg">
              <label>Nome da mãe</label>
              <input class="form-control" name="ownerMother{{i}}" [(ngModel)]="owner.motherName" [class.is-invalid]="nomeCompletoInvalido('socios', owner.motherName)">
            </div>
            <div class="field md">
              <label>Pessoa politicamente exposta?</label>
              <select class="form-control" name="ownerPep{{i}}" [(ngModel)]="owner.isPoliticallyExposedPerson">
                <option *ngFor="let item of respostasPep" [ngValue]="item.valor">{{item.nome}}</option>
              </select>
            </div>
          </div>

          <label class="check-card mt-2">
            <input type="checkbox" [(ngModel)]="owner.useBusinessAddress" name="ownerUseBusinessAddress{{i}}">
            <span><strong>Usar endereço comercial</strong><small>{{resumoEndereco(proposta.businessAddress)}}</small></span>
          </label>

          <ng-container *ngIf="!owner.useBusinessAddress">
            <ng-container *ngTemplateOutlet="enderecoFields; context: {endereco: owner.address, prefix: 'owner' + i}"></ng-container>
          </ng-container>
        </article>
        </div>
      </section>

      <section *ngIf="etapaAtual()?.id === 'endereco'" class="step-screen activation-card">
        <div class="activation-card-header">
          <div class="card-title-wrap">
            <div class="card-icon">UF</div>
            <div>
              <h2>Endereço</h2>
              <p>Confirme a localização vinculada ao cadastro.</p>
            </div>
          </div>
        </div>
        <div class="activation-card-body">
        <ng-container *ngTemplateOutlet="enderecoFields; context: {endereco: proposta.businessAddress, prefix: 'business'}"></ng-container>
        </div>
      </section>

      <section *ngIf="etapaAtual()?.id === 'revisao'" class="step-screen review-screen">
        <div class="section-title">
          <div>
            <h2>Resumo por etapa</h2>
            <p>Clique em editar para voltar à etapa correspondente.</p>
          </div>
        </div>

        <div class="review-grid">
          <article class="review-card" [ngClass]="classeCardEtapa('empresa')">
            <div class="review-card-head">
              <div>
                <h2>Conta</h2>
                <span>{{nomeCompanyType()}}</span>
              </div>
              <span class="review-badge">{{statusCardEtapa('empresa')}}</span>
            </div>
            <div class="review-lines">
              <div class="review-main">{{ehPessoaFisica() ? ownerPrincipal().fullName || 'Nome não informado' : proposta.tradingName || 'Nome fantasia'}}</div>
              <div class="review-line" *ngIf="!ehPessoaFisica()">
                <span class="review-icon">ID</span>
                <span>{{proposta.businessName || 'Razão social'}}</span>
              </div>
              <div class="review-line">
                <span class="review-icon">{{ehPessoaFisica() ? 'CPF' : 'CNPJ'}}</span>
                <span>{{documentoFormatado(proposta.documentNumber)}}</span>
              </div>
              <div class="review-line">
                <span class="review-icon">TEL</span>
                <span>{{ehPessoaFisica() ? telefoneResponsavelResumo() : telefoneFormatado(proposta.contactNumber)}}</span>
              </div>
              <div class="review-line">
                <span class="review-icon">@</span>
                <span>{{ehPessoaFisica() ? emailResponsavelResumo() : proposta.businessEmail || 'E-mail não informado'}}</span>
              </div>
            </div>
            <p class="review-warning" *ngIf="erroEtapa('empresa')">{{erroEtapa('empresa')}}</p>
            <button type="button" class="btn btn-link" (click)="voltePara('empresa')">Editar</button>
          </article>

          <article class="review-card" [ngClass]="classeCardEtapa('endereco')">
            <div class="review-card-head">
              <div>
                <h2>Endereço</h2>
                <span>{{enderecoLabel()}}</span>
              </div>
              <span class="review-badge">{{statusCardEtapa('endereco')}}</span>
            </div>
            <div class="review-lines">
              <div class="review-main">{{resumoEndereco(proposta.businessAddress)}}</div>
              <div class="review-line">
                <span class="review-icon">CEP</span>
                <span>{{proposta.businessAddress?.postalCode || 'CEP não informado'}}</span>
              </div>
              <div class="review-line">
                <span class="review-icon">UF</span>
                <span>{{proposta.businessAddress?.city || 'Cidade'}} / {{proposta.businessAddress?.state || 'UF'}}</span>
              </div>
            </div>
            <p class="review-warning" *ngIf="erroEtapa('endereco')">{{erroEtapa('endereco')}}</p>
            <button type="button" class="btn btn-link" (click)="voltePara('endereco')">Editar</button>
          </article>

          <article class="review-card" [ngClass]="classeCardEtapa('responsavel')">
            <div class="review-card-head">
              <div>
                <h2>Responsável</h2>
                <span>{{ehPessoaFisica() ? 'Titular da conta' : 'Representante legal'}}</span>
              </div>
              <span class="review-badge">{{statusCardEtapa('responsavel')}}</span>
            </div>
            <div class="review-lines">
              <div class="review-main">{{ownerPrincipal().fullName || 'Nome não informado'}}</div>
              <div class="review-line">
                <span class="review-icon">CPF</span>
                <span>{{cpfMascarado(ownerPrincipal().documentNumber)}}</span>
              </div>
              <div class="review-line">
                <span class="review-icon">TEL</span>
                <span>{{telefoneResponsavelResumo()}}</span>
              </div>
              <div class="review-line">
                <span class="review-icon">@</span>
                <span>{{emailResponsavelResumo()}}</span>
              </div>
            </div>
            <p class="review-warning" *ngIf="erroEtapa('responsavel')">{{erroEtapa('responsavel')}}</p>
            <button type="button" class="btn btn-link" (click)="voltePara('responsavel')">Editar</button>
          </article>

          <article class="review-card" *ngIf="!ehPessoaFisica() && proposta.companyType !== 'MEI' && quantidadeSociosAdicionais() > 0" [ngClass]="classeCardEtapa('socios')">
            <div class="review-card-head">
              <div>
                <h2>Sócios</h2>
                <span>Quadro societário</span>
              </div>
              <span class="review-badge">{{statusCardEtapa('socios')}}</span>
            </div>
            <div class="review-lines">
              <div class="review-main">{{quantidadeSociosAdicionais()}} sócio(s) adicional(is)</div>
              <div class="review-line">
                <span class="review-icon">CPF</span>
                <span>Documentos e dados pessoais</span>
              </div>
              <div class="review-line">
                <span class="review-icon">@</span>
                <span>E-mail e telefone dos sócios</span>
              </div>
            </div>
            <p class="review-warning" *ngIf="erroEtapa('socios')">{{erroEtapa('socios')}}</p>
            <button type="button" class="btn btn-link" (click)="voltePara('socios')">Editar</button>
          </article>

        </div>

        <article class="terms-consent" [class.is-invalid]="termoAceiteInvalido()">
          <div class="terms-copy">
            <span class="review-icon">TERMO</span>
            <div>
              <h2>Termos de uso e abertura da conta</h2>
              <p>
                Antes do envio, o responsável deve aceitar os termos do Meu Cardápio Pay e autorizar o uso dos dados
                para abertura da conta de pagamentos via Cellcoin.
              </p>
              <div class="terms-link-wrap" [class.is-shaking]="termosUsoLinkTremendo">
                <button type="button" class="btn btn-outline-primary btn-sm terms-open-button" (click)="abraTermosUso()">
                  Abrir termo de uso
                </button>
                <div class="terms-popover" *ngIf="termosUsoPopupAberto">
                  Leia o termo de uso antes de aceitar.
                </div>
              </div>
            </div>
          </div>

          <label class="terms-check">
            <input type="checkbox" name="termoAceito" [(ngModel)]="termoAceito" (click)="aoClicarAceiteTermos($event)">
            <span>Li e aceito os Termos de Uso do Meu Cardápio Pay e autorizo o envio dos dados para abertura da conta de pagamentos via Cellcoin.</span>
          </label>

          <p class="terms-error" *ngIf="termoAceiteInvalido()">Obrigatório aceitar os termos para enviar a proposta.</p>
        </article>

        <article class="next-steps-card">
          <div class="section-title">
            <div>
              <h2>Depois do envio</h2>
              <p>Entenda as próximas etapas da proposta.</p>
            </div>
          </div>
          <div class="timeline">
            <div class="timeline-step is-current">
              <span>1</span>
              <div>
                <strong>Enviar dados do cadastro</strong>
                <p>As informações preenchidas serão enviadas para abertura da proposta.</p>
              </div>
            </div>
            <div class="timeline-step">
              <span>2</span>
              <div>
                <strong>Validação facial e envio de documentos</strong>
                <p>Será gerado um link de ativação da conta para o responsável tirar foto, validar a identidade e enviar os documentos solicitados
                  durante a validação.</p>
              </div>
            </div>
            <div class="timeline-step">
              <span>3</span>
              <div>
                <strong>Ativação da conta</strong>
                <p>Após aprovação, a conta de pagamento é ativada e o Meu Cardápio Pay libera as formas de pagamento.</p>
              </div>
            </div>
          </div>
        </article>
      </section>
    </main>

    <div class="loading-state" *ngIf="carregando">
      <span class="spinner-border spinner-border-sm mr-2"></span>
      Carregando dados da empresa
    </div>

    <footer class="wizard-footer" *ngIf="!carregando">
      <button type="button"
              class="btn btn-outline-secondary wizard-action wizard-action-back"
              (click)="voltar()"
              [disabled]="indiceEtapa === 0 || enviando">
        Voltar
      </button>
      <div class="wizard-action-next-group">
        <button type="button"
                class="btn btn-primary wizard-action wizard-action-next"
                (click)="avancar()"
                [disabled]="enviando">
          <span class="spinner-border spinner-border-sm mr-1" *ngIf="enviando"></span>
          {{etapaAtual()?.id === 'revisao' ? 'Enviar Cadastro' : 'Continuar'}}
        </button>
        <div class="wizard-footer-error" *ngIf="mensagemErroRodape">
          <i class="fas fa-exclamation-circle"></i>
          <span>{{mensagemErroRodape}}</span>
        </div>
      </div>
    </footer>
  </section>
</div>

<ng-template #enderecoFields let-endereco="endereco" let-prefix="prefix">
  <div class="form-grid address-grid">
    <div class="field md">
      <label>CEP</label>
      <input class="form-control" name="{{prefix}}PostalCode" [(ngModel)]="endereco.postalCode"
             mask="00000-000" placeholder="00000-000" [class.is-invalid]="enderecoCampoInvalido(prefix, 'postalCode', endereco)">
    </div>
    <div class="field lg">
      <label>Logradouro</label>
      <input class="form-control" name="{{prefix}}Street" [(ngModel)]="endereco.street"
             [class.is-invalid]="enderecoCampoInvalido(prefix, 'street', endereco)">
    </div>
    <div class="field sm">
      <label>Número</label>
      <input class="form-control" name="{{prefix}}Number" [(ngModel)]="endereco.number"
             [class.is-invalid]="enderecoCampoInvalido(prefix, 'number', endereco)">
    </div>
    <div class="field">
      <label>Bairro</label>
      <input class="form-control" name="{{prefix}}Neighborhood" [(ngModel)]="endereco.neighborhood"
             [class.is-invalid]="enderecoCampoInvalido(prefix, 'neighborhood', endereco)">
    </div>
    <div class="field md">
      <label>Cidade</label>
      <input class="form-control" name="{{prefix}}City" [(ngModel)]="endereco.city"
             [class.is-invalid]="enderecoCampoInvalido(prefix, 'city', endereco)">
    </div>
    <div class="field sm">
      <label>UF</label>
      <input class="form-control" name="{{prefix}}State" [(ngModel)]="endereco.state" maxlength="2"
             [class.is-invalid]="enderecoCampoInvalido(prefix, 'state', endereco)">
    </div>
    <div class="field md">
      <label>Complemento</label>
      <input class="form-control" name="{{prefix}}Complement" [(ngModel)]="endereco.addressComplement">
    </div>
  </div>
</ng-template>
